import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";

const SecureAuth0Handler = () => {
  const { isAuthenticated, isLoading, getIdTokenClaims } =
    useAuth0();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const redirectUrl = params.get("redirectUrl");
  const flowType = params.get("flowType");
  const [error, setError] = useState(null);
  const setToken = async () => {
          const id_token = await getIdTokenClaims();
          if (id_token) {
            try {
              const decoded = jwtDecode(id_token.__raw);
              const email = decoded.email;
              try {
                const url = new URL(redirectUrl);
                url.searchParams.set("infoField1", email);
                window.location.replace(url.toString());
              } catch (e) {
                setError("Invalid redirectUrl");
              }
            } catch (e) {
              setError("Error decoding id_token");
            }
          } else { 
            setError("Error getting id_token");
          }
      };
  useEffect(() => {
    if(redirectUrl && flowType === "amazon") {
      if (!isLoading && isAuthenticated) {
        setToken();
      } else {
        setError("loading...");
      }
    } else {
      const defaultRedirectUrl = process.env.REACT_APP_AIA_DEFAULT;
      window.location.replace(defaultRedirectUrl.toString());
    }
  }, [isLoading, isAuthenticated]);

  if (error) {
    return <div>{error}</div>;
  }
  // Optionally, you can return null or a loading indicator here
  return null;
};

export default SecureAuth0Handler;
